<template>
	<div id="eventos-page">
		<div class="container">
			<h3>Eventos</h3>
			<h1>Próximos eventos</h1>
			<div class="eventos-row" v-if="isCargandoEventos && eventos.length <= 0">
					<SkeletonEventoCard class="evento" v-for="eve in 4" :key="eve" :isDarkMode="false" />
				</div>
			<div class="eventos-row" v-else>
				<EventCardAux v-for="eve in eventos" :evento="eve" :key="eve.Evento.EventoId" @click="irAEvento(eve.Evento.EventoId, eve.Evento.EventoSlug)" />
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import EventCardAux from "../components/eventos/EventCardAux.vue";
	import SkeletonEventoCard from "../components/skeletons/SkeletonEventoCard.vue";

	export default {
		data() {
			return {
				isCargandoEventos: true,
				eventos: [],
			};
		},
		components: {
			EventCardAux,
			SkeletonEventoCard
		},
		metaInfo: {
			title: 'Todos los eventos',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		async mounted() {
			await this.getEventos();
		},
		methods: {
			irAEvento(id, slug) {
				this.$router.push({ name: 'evento', params: { eventSlug: slug, eventId: id } });
			},
			async getEventos(){
				try {
					this.isCargandoEventos = true

					let response = await axios.post('/WSEventos', {
						Pag: 1,
						Limit: 100,
						IsDesdeRedpagos: false
					});

					if(response.data.ErrorCod === 0){
						this.eventos = response.data.SDTEventos
					}
				} catch (error) {
					console.log('Ocurrió un error al cargar los eventos');
				} finally {
					this.isCargandoEventos = false
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	#eventos-page{
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 60px 0px;

		h3 {
			font-size: 12px;
			font-weight: var(--fw-600);
			letter-spacing: 0.3px;
			font-family: var(--font-sora);
			color: var(--color-darker);
			text-transform: capitalize;
		}

		h1 {
			margin: 0;
			margin-top: 10px;
			margin-bottom: 40px;
			font-family: var(--font-sora);
			font-size: 30px;
			line-height: 1em;
		}

		.eventos-row {
			width: 100%;
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			grid-auto-rows: 1fr;
			grid-column-gap: 20px;
			grid-row-gap: 20px;
			margin: 10px 0px;
		}
	}

	@media screen and (max-width: 1400px){
		#eventos-page{
			padding: 30px 0px;
			.container{
				padding-left: 24px;
				padding-right: 24px;
			}
		}
	}

	@media screen and (max-width: 1300px){
		#eventos-page{
			.eventos-row{
				grid-template-columns: repeat(3, 1fr);
			}
		}
	}

	@media screen and (max-width: 890px){
		#eventos-page{
			.eventos-row{
				grid-template-columns: repeat(2, 1fr);
			}
		}
	}

	@media screen and (max-width: 620px){
		#eventos-page{
			h3 {
				font-size: 11px;
			}

			h1 {
				margin-top: 5px;
				margin-bottom: 20px;
				font-size: 22px;
			}

			.eventos-row{
				grid-template-columns: repeat(1, 1fr);
			}
		}
	}
</style>